import { FormEvent, useState } from 'react';
import { useNavigate } from 'react-router';
import { Button, Input, Textarea } from '#atoms';
import { useToast } from '#providers/ToastProvider';
import { useUserInfo } from '#providers/UserInfo';
import { PrevHeaderBarWithTitleTemplate } from '#templates';
import Title from 'src/refactor_components/common/Title';
import { useQueryClient } from '@tanstack/react-query';
import { useForm } from 'react-hook-form';

export function IntroEdit() {
  const queryClient = useQueryClient();
  const { userInfo, patchProfile } = useUserInfo();
  const { register, getValues, handleSubmit } = useForm({
    defaultValues: {
      shortIntroduction: userInfo?.shortIntroduction,
      introduction: userInfo?.introduction
    }
  });

  const { showToast } = useToast();

  const navigate = useNavigate();

  const onPatchIntro = () => {
    patchProfile(
      {
        introduction: getValues('introduction'),
        shortIntroduction: getValues('shortIntroduction')
      },
      {
        onSuccess: () => {
          showToast({
            message: '소개글 등록에 성공하였습니다.'
          });
          queryClient.invalidateQueries({
            predicate: query => query.queryKey[0] === 'MYACCOUNT'
          });
          navigate(-1);
        },
        onError: () => {
          showToast({
            type: 'fail',
            message: '소개글 등록에 실패하였습니다.'
          });
        }
      }
    );
  };

  return (
    <PrevHeaderBarWithTitleTemplate title="" headerbarType="relative">
      <div className="p-20">
        <form
          onSubmit={handleSubmit(() => onPatchIntro())}
          className="flex gap-40 flex-col justify-between h-full"
        >
          <div className="flex flex-col gap-20">
            <div className="flex flex-col gap-10">
              <Title className="text-[16px]" text="한 줄 소개">
                <p className="text-[#9170F2] text-[12px]">최대 30자</p>
              </Title>
              <input
                {...register('shortIntroduction', {
                  maxLength: {
                    value: 30,
                    message: '최대 30자까지 입력 가능합니다.'
                  }
                })}
                type="text"
                className="w-full bg-transparent p-10 text-16 rounded-[5px] h-53 placeholder:text-[#999] border border-solid border-[var(--color-gray-second)]"
                placeholder="나를 가장 잘 표현할 수 있는 한 줄 소개"
                maxLength={30}
              />
            </div>

            <div className="flex flex-col gap-10">
              <Title className="text-[16px]" text="소개글">
                <p className="text-[#9170F2] text-[12px]">최대 1000자</p>
              </Title>
              <textarea
                {...register('introduction', {
                  maxLength: {
                    value: 1000,
                    message: '최대 1000자까지 입력 가능합니다.'
                  }
                })}
                className="h-288 w-full bg-transparent p-10 text-16 rounded-[5px] placeholder:text-[#999] border border-solid border-[var(--color-gray-second)]"
                maxLength={1000}
                placeholder="본인의 트레이닝 경험을 기반으로 회원들에게 더 보여주고 싶은 내용을 담아보세요."
              />
            </div>
          </div>
          <Button>프로필 등록</Button>
        </form>
      </div>
    </PrevHeaderBarWithTitleTemplate>
  );
}
